import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { Order } from 'core/models/order';
import { HttpDataService } from './http-data.service';

@Injectable()
export class OrdersService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/subscriptions/orders');
  }

  resolve(): Promise<Order[]> | Order[] {
    return this.fetch({}).then((orders) => orders['docs']);
  }

  getOrder(id: string): Observable<Order> {
    return super.getItem(id);
  }
}
